module.exports = __webpack_public_path__ + "static/media/Rujuta_Budke.054f010d.jpg";